/* eslint-disable max-len */
const LoginStatIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6481 13.6001V10.4001C22.6481 8.63276 21.2154 7.20007 19.4481 7.20007H8.2481C6.48078 7.20007 5.0481 8.63276 5.0481 10.4001V29.6001C5.0481 31.3674 6.48078 32.8001 8.2481 32.8001H19.4481C21.2154 32.8001 22.6481 31.3674 22.6481 29.6001V26.4001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2481 20.7501C32.6623 20.7501 32.9981 20.4143 32.9981 20.0001C32.9981 19.5859 32.6623 19.2501 32.2481 19.2501V20.7501ZM11.4481 20.0001L10.9178 19.4697C10.7033 19.6842 10.6391 20.0068 10.7552 20.2871C10.8713 20.5673 11.1448 20.7501 11.4481 20.7501V20.0001ZM16.7784 15.7304C17.0713 15.4375 17.0713 14.9626 16.7784 14.6697C16.4856 14.3768 16.0107 14.3768 15.7178 14.6697L16.7784 15.7304ZM15.7178 25.3304C16.0107 25.6233 16.4856 25.6233 16.7785 25.3304C17.0713 25.0375 17.0713 24.5626 16.7785 24.2697L15.7178 25.3304ZM11.9785 19.4697C11.6856 19.1769 11.2107 19.1769 10.9178 19.4697C10.6249 19.7626 10.6249 20.2375 10.9178 20.5304L11.9785 19.4697ZM32.2481 19.2501H11.4481V20.7501H32.2481V19.2501ZM11.9785 20.5304L16.7784 15.7304L15.7178 14.6697L10.9178 19.4697L11.9785 20.5304ZM16.7785 24.2697L11.9785 19.4697L10.9178 20.5304L15.7178 25.3304L16.7785 24.2697Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LoginStatIcon;
